/* eslint-disable react/prop-types */
import React, { useEffect, useState, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Table, Select, notification, Popconfirm,
} from 'antd';
import { v4 as uuidv4 } from 'uuid';
import TenantActions from '@Actions/tenantActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import BusyIntegrationActions from '../../../../../../../actions/integrations/busyIntegrationAction';
import './style.scss';
import BusyTabLoading from '../../BusyTabLoading';
import PRZSelect from '../../../../../../Common/UI/PRZSelect';

const { Option } = Select;

const BusyMapTaxes = ({
  user, getTenants, getTenantsLoading, tenants,
  connectToBusyLocationLoading, setStep, getBusyConnections,
  connectToBusyLocation, getBusyConnectionsLoading,
  integrationBusyId, busyConnections, stepNumber,
}) => {
  const [tenantData, setTenantData] = useState('');
  const [busyConnectionsFilterData, setBusyConnectionsFilterData] = useState('');

  useEffect(() => {
    getTenants(1, '', true, user?.tenant_info?.org_id);
    const filterData = busyConnections?.filter((item) => item?.integration_busy_id === integrationBusyId);
    setBusyConnectionsFilterData(filterData);
  }, [busyConnections]);

  useEffect(() => {
    const copyTenantData = busyConnectionsFilterData?.[0]?.taxes_mapping?.filter((item) => item?.procuzy_tax !== null)?.map((tenant) => ({
      key: uuidv4(),
      busy_tax_name: tenant?.busy_tax_name,
      procuzy_tax: tenant?.procuzy_tax,
      ...tenant,
    }));
    setTenantData(copyTenantData);
  }, [tenants, busyConnectionsFilterData]);

  const updateTableValue = (key, value, label) => {
    const data = tenantData.map((tenant) => {
      if (tenant.key === key) {
        // eslint-disable-next-line no-param-reassign
        tenant[label] = value;
        return tenant;
      }
      return tenant;
    });
    setTenantData(data);
  };

  const columns = [
    {
      title: 'Procuzy Taxes',
      width: '312px',
      render: (record) => (
        <div>
          {record?.procuzy_tax}
          {record?.required && (<span style={{ color: 'red', fontSize: '15px' }}> *</span>) }
        </div>
      ),
    },
    {
      title: 'Busy Taxes',
      render: (record) => (
        <div>
          <PRZSelect
            value={record.busy_tax_name}
            filterOption={false}
            onChange={(value) => {
              updateTableValue(record?.key, value, 'busy_tax_name');
            }}
            placeholder="Select a location"
            dropdownAlign={{ offset: [-6, 4] }}
            disabled={connectToBusyLocationLoading || getBusyConnectionsLoading}
            allowClear
          >
            {busyConnectionsFilterData && busyConnectionsFilterData?.filter((connection) => connection?.company_name && connection?.taxes)?.[0]?.taxes
              ?.map((item) => (
                <Option key={item.name} value={item.name}>
                  {item?.name}
                </Option>
              ))}
          </PRZSelect>
        </div>
      ),
    },
  ];

  let finalData = [];
  if (tenantData?.length > 0) {
    finalData = tenantData?.filter((obj) => obj.busy_tax_name !== undefined && obj.busy_tax_name !== null);
  }

  const handleSubmit = () => {
    if (finalData?.length > 0) {
      const payload = {
        integration_busy_id: integrationBusyId,
        taxes_mapping: finalData,
      };
      connectToBusyLocation(payload, () => {
        setStep(Number(stepNumber)+1);
      });
    } else {
      notification.error({
        message: 'Please select at least one Tax',
        placement: 'top',
        duration: 4,
      });
    }
  };

  if ((getTenantsLoading || getBusyConnectionsLoading)) return <BusyTabLoading />;
  return (
    <div className="busy__taxes-wrapper">
      <div className="ant-row">
        <div className="ant-col-md-12">
          <Table
            columns={columns}
            loading={getTenantsLoading || connectToBusyLocationLoading || getBusyConnectionsLoading}
            dataSource={tenantData}
            size="small"
            pagination={false}
            bordered
          />
        </div>
      </div>
      <div className="ant-row" style={{ display: 'flex', marginTop: '20px' }}>
        <H3Button
          text="Back"
          buttonType={defaultButtonTypes.BLUE_BORDERED}
          onClick={() => setStep(3)}
          customClass="busy__action-button"
          disabled={connectToBusyLocationLoading || getBusyConnectionsLoading}
        />
                &nbsp;&nbsp;
                &nbsp;&nbsp;
        <div>
          <H3Button
            text="Save and Continue"
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            onClick={() => handleSubmit()}
            customClass="busy__location-submit"
            isLoading={connectToBusyLocationLoading || getBusyConnectionsLoading}
            disabled={connectToBusyLocationLoading || getBusyConnectionsLoading}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, TenantReducers, BusyIntegrationReducers,
}) => ({
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  connectToBusyLocationLoading: BusyIntegrationReducers.connectToBusyLocationLoading,
  getBusyConnectionsLoading: BusyIntegrationReducers.getBusyConnectionsLoading,
  getTenantsLoading: TenantReducers.getTenantsLoading,
  busyConnections: BusyIntegrationReducers.busyConnections,
});
const mapDispatchToProps = (dispatch) => ({
  getTenants: (page, keyword, isVerified, orgId) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId),
  ),
  getBusyConnections: (orgId, callback) => dispatch(BusyIntegrationActions.getBusyConnections(orgId, callback)),
  connectToBusyLocation: (payload, callback) => dispatch(BusyIntegrationActions.connectToBusyLocation(payload, callback)),
});

BusyMapTaxes.propTypes = {
  user: PropTypes.any,
  getTenants: PropTypes.func,
  getTenantsLoading: PropTypes.bool,
  tenants: PropTypes.any,
  connectToBusyLocationLoading: PropTypes.bool,
  getBusyConnectionsLoading: PropTypes.bool,
  setStep: PropTypes.func,
  getBusyConnections: PropTypes.func,
  connectToBusyLocation: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BusyMapTaxes));
